module.exports = __webpack_public_path__ + "img/kovatek-note.fb4cccf3.png";